import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const Login = () => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  if (isAuthenticated) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(form.email.trim(), form.password);
      navigate("/", { replace: true });
    } catch (e) {
      setErr(e.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#f9fafa] dark:bg-neutral-950">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-800 rounded-2xl p-6 shadow"
      >
        <h1 className="text-xl font-semibold text-driveeasy-blue dark:text-driveeasy-yellow mb-4">
          DriveEasy Admin Login
        </h1>

        {err && <div className="mb-3 text-sm text-red-600">{err}</div>}

        <label className="block mb-2 text-sm text-gray-600 dark:text-gray-300">Email</label>
        <input
          type="email"
          required
          className="w-full p-2 rounded border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 dark:text-gray-100 mb-4"
          value={form.email}
          onChange={e=>setForm({...form, email: e.target.value})}
        />

        <label className="block mb-2 text-sm text-gray-600 dark:text-gray-300">Password</label>
        <input
          type="password"
          required
          className="w-full p-2 rounded border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 dark:text-gray-100 mb-6"
          value={form.password}
          onChange={e=>setForm({...form, password: e.target.value})}
        />

        <button
          disabled={loading}
          className="w-full py-2 rounded bg-driveeasy-blue text-white hover:bg-driveeasy-yellow hover:text-black transition"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default Login;
